import config from './app/data/config.json';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import "./app/css/landdescifn.css";

import bootstrap from "bootstrap/dist/js/bootstrap.bundle.min.js";

// idioma
const path = window.location.pathname;
let lang = localStorage.getItem('lang');
if (!lang) {
	// elijo automáticamente a partir del lenguaje del navegador
	const preflangs = window.navigator.languages || [window.navigator.language || window.navigator.userLanguage];
	for (let ltag of preflangs) {
		const langev = ltag.substring(0, 2);
		if (config.langs.includes(langev)) {
			lang = langev;
			break;
		}
	}
	if (!lang)
		lang = config.langs[0]; // inglés
}
// si el path está bien, pongo el listener
if (((path === "/" || path === "") && lang === "en") || ((path === "/es" || path === "/es/") && lang === "es")) {
	// handler del radio con el idioma
	document.querySelectorAll('input[type=radio][name=btnradio]').forEach(function(radio) {
		radio.addEventListener('change', function() {
			// recojo idioma y guardo
			const lang = this.getAttribute('id');
			localStorage.setItem('lang', lang);
			const newpath = window.location.pathname;
			// miro si hay que cambiar
			if ((newpath === "/" || newpath === "") && lang === "es") // prefiere español
				window.location.href = '/es';
			else if ((newpath === "/es" || newpath === "/es/") && lang === "en") // prefiere inglés
				window.location.href = '/';
		});
	});
}
else // path incorrecto, lo reajusto
	window.location.href = lang === "es"? '/es' : '/';
	

// versión
let vers = lang === "es"? "Versión " : "Version ";
vers += config.version + " (" + config.versionCode + ")";
document.getElementById('version').innerHTML = vers;